import req from "../http";

const permission = {
  // 取得 選單功能(分頁)
  getPermissionPaging(params) {
    return req("get", "/auth/permission/paging", params);
  },

  // 取得 選單功能
  getPermission(guid) {
    return req("get", `/auth/permission/${guid}`);
  },

  // 新增 選單功能
  postPermission(params) {
    return req("post", "/auth/permission", params);
  },

  // 更新 選單功能 
  putPermission(params) {
    return req("put", "/auth/permission", params);
  },

  // 刪除 選單功能 
  deletePermission(guid) {
    return req("delete", `/auth/permission/${guid}`);
  },
};

export default permission;